import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import axios from 'axios'

import Button from 'jd-library/Button';
import SliderHeader from 'jd-library/SliderHeader';

import {setLoggedUser} from '../../actions/index';
import {fetchEnrichUrl,logOut} from '../../utills';
import MorePopover from 'jd-library/MorePopover';
import {setAuditObject} from '../../actions/products'; /* need to remove */
import '../../pages/contractor-home/home.scss';
import { showToastMessage } from '../../actions/toastmessage';


const ContractorMainV4 = props => {
    const [enrichBtnLoader,updateEnrichBtnLoader] = useState(false);
    const [startPopoverRef, setStartPopoverRef] = React.useState('');

    let allowedContractors = ["CONTRACTORV4"];

    let history = useHistory();

    const [enrichStats,updateEnrichStats] = useState({
        brandedQueuCount:0,
        customQueueCount:0
    });
    const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
	);
    const handleScroll = useCallback(() => {
		let isScrolled = document.scrollingElement.scrollTop > 0 ? true : false;
		setScroll(isScrolled);
	}, []);

    useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

    const startList=[{
        key: '1',
        label: 'Enrich Branded Product Queue',
        className: enrichStats.brandedQueuCount ? 'star-item-list' : 'star-item-list disable-item'
    },{
        key: '2',
        label: 'Enrich Custom Product Queue',
        className: enrichStats.customQueueCount ? 'star-item-list' : 'star-item-list disable-item'
    }];


	const startOptionClick = (obj) => {
        let queueType = 'brandedQueue';
        if(obj.key == '2'){
            queueType = 'customQueue';
            if(!enrichStats.customQueueCount) {
                return;
            }
        } else if(obj.key == '1'){
            queueType = 'brandedQueue';
            if(!enrichStats.brandedQueuCount) {
                return;
            }
        }
        updateEnrichBtnLoader(true);

        fetchEnrichUrl({
          queueType,
          cb: (options = {}) => {
            let { url} = options;
            if(url != '') {
                if(window.top != window.self) {
                    url += '&loadedInIframe=true';
                }
                window.location.href = url;
            } else {
                alert("No Products Found.");
            }
            updateEnrichBtnLoader(false);
          }
        });
	}



    let rightIconArray = [{
        isMoreMenu: true,
        options: [{label: "Log Out",
                    onClick: () => {
                        logOut({
                            token: props.session.token,
                            cb: (data) => {
                                if(data.data.isSuccess){
                                    props.setLoggedUser(null)
                                    history.push("/contractor-login/v4");
                                } else {
                                    console.log('unable to logout');
                                }
                            }
                        });
                    },
                    className: "enrich-right-menu"
                }]
    }];

    useEffect(() => {
		if(props.session.user.loginData && (!props.session.user.loggedUser || (props.session.user.loggedUser && allowedContractors.indexOf(props.session.user.loggedUser.subType) == -1))){
            history.push('/contractor-login/v4');
		}
    },[props.session.user.loginData]);
    useEffect(()=>{
        let enrichStatsData = {...enrichStats}

        axios.get(`/vendorapis/contractor/contractor/getContractorQueueCount`).then((data) => {
            if(data.data.results){
                enrichStatsData = data.data.results;
                updateEnrichStats(enrichStatsData);
            }
        });
    },[]);
    let EnrichButton = '';
    if (
        enrichStats.brandedQueuCount ||
        enrichStats.customQueueCount
      ) {
        EnrichButton = (
          <div
            style={{ position: "relative", textAlign: "center", width: "100%" }}
            className={"start-now-btn"}
            ref={(r) => setStartPopoverRef(r)}
          >
            <MorePopover
              list={startList}
              onOptionClick={startOptionClick}
              containerRef={startPopoverRef}
              style={{ width: "100%" }}
              fixToBottom={true}
              eventType="click"
              className={"start-enrich-popup"}
            >
              <Button
                className={"action-btn"}
                showLoader={enrichBtnLoader}
                size="lg"
                block
              >
                Start Enriching Products Now
              </Button>
            </MorePopover>
          </div>
        );
      } else {
        EnrichButton = (
          <Button
            className={"action-btn disabled-btn"}
            showLoader={enrichBtnLoader}
            size="lg"
            block
          >
            Start Enriching Products Now
          </Button>
        );
      }
      return (
        <>
          <SliderHeader
            heading={"B2B Enrich Products Module"}
            rightIcons={rightIconArray}
            variant="secondary"
            className={isScrolled ? "enrich-header-unset" : ""}
            raised={isScrolled}
          />
          <div className={"enrich-home"}>
            <div className={"paddingLR15 top-section"}>
              <div className={"logged-in-header"}>{"Enrich Products"}</div>
              <div className={"logged-in-text"}>
                {
                  "You can click on Start Enriching Products Now button to enrich product."
                }
              </div>
              {EnrichButton}
            </div>
            <div className={"enrich-stats paddingLR15 top-section"}>
              <div className={"enrich-header"}>
                <div className={"logged-in-header"}>Enrich Stats</div>
                <div className={"header-date"}>
                  <span className={"date-holder-text"}>Last Updated </span>
                  <span>{enrichStats.lastUpdated}</span>
                </div>
              </div>
              <div>
                <div className={"text-spacing"}>
                  {"Enrich Branded Product Queue: " +
                    enrichStats.brandedQueuCount}
                </div>
                <div className={"text-spacing"}>
                  {"Enrich Custom Product Queue: " +
                    enrichStats.customQueueCount}
                </div>
              </div>
            </div>
          </div>
        </>
      );
};

const mapStateToProps = state => {
	return {
		session: state.session,
		enrichData: state.products.auditData,//need to change
		deviceData: state.deviceData
	};
};

export default connect(mapStateToProps,{setLoggedUser,setAuditObject/* need to change */,showToastMessage})(ContractorMainV4);
